// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import instadate from 'instadate';
import { formActions, mergeActionsToProps } from 'redux-pure-form';

import type { MapStateToProps } from 'react-redux';

import Select from '../../form/select.js';
import SortingArrows from '../sorting-arrows.js';
import { setModal } from '../../ui/ui.actions.js';

import {
  DISCREPANCY_ADD,
  DISCREPANCY_VIEW,
  discrepancyStatuses,
  statusNames,
  statusOptions,
  discrepancyPriorities,
  priorityOptions
} from '../calendar.consts.js';

import { selectDiscrepancies, selectAssignToOptions } from '../calendar.selectors.js';

import { dateFormatSettings, timeFormatSettings } from '../../settings/settings.consts.js';

import { formatDate } from '../calendar.model.js';

import { changeStatus, saveDiscrepancy } from '../calendar-day.actions.js';

type OwnProps = {||};

type MappedState = {|
  UI: UI,
  URL: URL
|};

type Props = {|
  ...OwnProps,
  ...MappedState
|};

class Discrepancies extends React.Component<Props> {
  static footer = true;

  constructor(props: Props) {
    super(props);
    this.handleDiscrepancyAdd = this.handleDiscrepancyAdd.bind(this);
    this.handleDiscrepancyView = this.handleDiscrepancyView.bind(this);
    this.handleDiscrepancyFilterStatusChange = this.handleDiscrepancyFilterStatusChange.bind(this);
    this.handleSortingClick = this.handleSortingClick.bind(this);
    this.handleDiscrepancyEditModalOpen = this.handleDiscrepancyEditModalOpen.bind(this);
    this.handleDiscrepancyChange = this.handleDiscrepancyChange.bind(this);
  }

  handleDiscrepancyAdd: Function;
  handleDiscrepancyAdd(e) {
    const nextBreadcrumbs = this.props.URL.eventBreadcrumbs.concat({
      ...this.props.URL.eventParams,
      action: DISCREPANCY_ADD
    });

    return this.props.switchModals(
      DISCREPANCY_ADD,
      {
        ...this.props.URL.eventParams,
        action: DISCREPANCY_ADD
      },
      nextBreadcrumbs
    );
  }

  handleDiscrepancyView: Function;
  handleDiscrepancyView(e) {
    if (e.target.nodeName === 'TD') {
      const discrepancyid = e.currentTarget.dataset.id;
      const nextBreadcrumbs = this.props.URL.eventBreadcrumbs.concat({
        ...this.props.URL.eventParams,
        action: DISCREPANCY_VIEW,
        discrepancyid
      });

      return this.props.switchModals(
        DISCREPANCY_VIEW,
        {
          ...this.props.URL.eventParams,
          discrepancyid,
          action: DISCREPANCY_VIEW
        },
        nextBreadcrumbs
      );
    }
    return false;
  }

  handleDiscrepancyFilterStatusChange: Function;
  handleDiscrepancyFilterStatusChange(e) {
    const { status } = e.currentTarget.dataset;
    if (this.props.aircraft.discrepancyStatus === status) return false;

    return this.props.fieldAttrs.onChange('aircraft.discrepancyStatus', status);
  }

  handleSortingClick: Function;
  handleSortingClick(e) {
    const { direction, field } = e.currentTarget.dataset;
    if (
      this.props.aircraft.sortingField === field &&
      this.props.aircraft.sortingDirection === direction
    )
      return false;

    if (this.props.aircraft.sortingDirection !== direction) {
      this.props.fieldAttrs.onChange('aircraft.sortingDirection', direction);
    }

    if (this.props.aircraft.sortingField !== field) {
      return this.props.fieldAttrs.onChange('aircraft.sortingField', field);
    }

    return false;
  }

  handleDiscrepancyEditModalOpen: Function;
  handleDiscrepancyEditModalOpen(e) {
    const { field, id } = e.currentTarget.dataset;
    const activeDiscrepancyEdit = Object.keys(this.props.UI.modals).find(key =>
      key.includes('DISCR-EDIT-')
    );
    if (activeDiscrepancyEdit) this.props.setModal(false, activeDiscrepancyEdit);
    return this.props.setModal(true, `DISCR-EDIT-${field}-${id}`);
  }

  handleDiscrepancyChange: Function;
  handleDiscrepancyChange(field, id, value) {
    if (field === 'status') {
      return this.props.changeStatus(id, value);
    }
    if (field === 'assignTo') {
      return this.props.saveDiscrepancy(id, {
        [field]: value,
        assignedName: this.props.mechanics[value].name,
        assignedSurname: this.props.mechanics[value].surname
      });
    }
    return this.props.saveDiscrepancy(id, { [field]: value });
  }

  render() {
    const { UI, URL, user, accessgroups, aircraft, discrepanciesList } = this.props;

    if (!aircraft || !aircraft.id) return null;

    return (
      <div className="discrepancies-section-wrap">
        <div className="text-center discrepancies-heading">
          <div className="discrepancies-modal-heading-wrap">
            <h5 className="discrepancies-modal-heading">
              Discrepancies{' '}
              {accessgroups.discrepanciesAdd ? (
                <button
                  type="button"
                  className="btn btn-sm btn-success"
                  onClick={this.handleDiscrepancyAdd}
                  disabled={UI.progress}
                >
                  <i className="icon plus-circled" /> Add
                </button>
              ) : null}
            </h5>
            <div>
              {discrepancyStatuses.map(status => (
                <span className="discrepancy-statuses-btn" key={`filter-${status.unique}`}>
                  {status.unique === 'closed' ? (
                    <div className="discrepancies-delimiter-filter discrepancy-statuses-closed" />
                  ) : null}
                  <button
                    type="button"
                    key={status.unique}
                    data-status={status.unique}
                    className={`btn btn-transparent discrepancy-statuses-btn-transparent ${
                      aircraft.discrepancyStatus === status.unique ? 'active' : ''
                    }`}
                    onClick={this.handleDiscrepancyFilterStatusChange}
                  >
                    {status.name}
                  </button>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table discrepancies-table table-hover {{ (_model == 'calendar' ? 'calendar')}}">
            <thead>
              <tr>
                <th>Name</th>
                <th className="table-header status-td">
                  <div className="sorting-table-wrap">
                    <span className="sorting-table-label">Status</span>
                    <SortingArrows
                      field="status"
                      onClick={this.handleSortingClick}
                      sortingField={aircraft.sortingField}
                      sortingDirection={aircraft.sortingDirection}
                    />
                  </div>
                </th>
                <th className="table-header priority-td">
                  <div className="sorting-table-wrap">
                    <span className="sorting-table-label">Priority</span>
                    <SortingArrows
                      field="priority"
                      onClick={this.handleSortingClick}
                      sortingField={aircraft.sortingField}
                      sortingDirection={aircraft.sortingDirection}
                    />
                  </div>
                </th>
                <th className="table-header">
                  <div className="sorting-table-wrap">
                    <span className="sorting-table-label">Assigned To</span>
                    <SortingArrows
                      field="assignedName"
                      onClick={this.handleSortingClick}
                      sortingField={aircraft.sortingField}
                      sortingDirection={aircraft.sortingDirection}
                    />
                  </div>
                </th>
                <th className="table-header date-td">
                  <div className="sorting-table-wrap">
                    <span className="sorting-table-label">Date</span>
                    <SortingArrows
                      field="date"
                      onClick={this.handleSortingClick}
                      sortingField={aircraft.sortingField}
                      sortingDirection={aircraft.sortingDirection}
                    />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {discrepanciesList.length ? (
                discrepanciesList.map(discrepancyID => {
                  const discrepancy = aircraft.discrepancies[discrepancyID];
                  const discrepancyTimestamp =
                    instadate.resetTimezoneOffset(new Date(discrepancy.date)).getTime() / 1000;
                  return (
                    <tr
                      key={discrepancyID}
                      data-id={discrepancyID}
                      onClick={accessgroups.discrepanciesView ? this.handleDiscrepancyView : null}
                    >
                      <td>
                        <b>{discrepancy.name}</b>
                        <br />
                        <span className="discrepancy-description">
                          {discrepancy.description && discrepancy.description.length > 35
                            ? discrepancy.description.slice(0, 35).concat('...')
                            : discrepancy.description}
                        </span>
                        <br />
                        <span className="discrepancy-signature">
                          <b>By: </b>
                          {discrepancy.signature}
                        </span>
                      </td>

                      <td
                        className="text-left"
                        data-field="status"
                        data-id={discrepancyID}
                        onClick={
                          accessgroups.discrepanciesStatus
                            ? this.handleDiscrepancyEditModalOpen
                            : null
                        }
                      >
                        {UI.modals[`DISCR-EDIT-status-${discrepancyID}`] ? (
                          accessgroups.discrepanciesStatus ? (
                            <Select
                              pretty
                              searchable={false}
                              clearable={false}
                              disabled={UI.progress}
                              className="discrepancy-field"
                              options={statusOptions}
                              value={aircraft.discrepancies[discrepancyID].status}
                              onChange={this.handleDiscrepancyChange.bind(
                                this,
                                'status',
                                discrepancyID
                              )}
                            />
                          ) : null
                        ) : (
                          <div
                            className={`discrepancy-field form-control-static no-border
                                  ${!accessgroups.discrepanciesStatus ? ' no-edit' : ''}`}
                          >
                            {statusNames[discrepancy.status]}
                            <span className="discrepancy-field-view-icon">
                              <span className="icon pencil" />
                            </span>
                          </div>
                        )}
                      </td>

                      <td
                        className="text-left"
                        data-field="priority"
                        data-id={discrepancyID}
                        onClick={
                          accessgroups.discrepanciesManage
                            ? this.handleDiscrepancyEditModalOpen
                            : null
                        }
                      >
                        {UI.modals[`DISCR-EDIT-priority-${discrepancyID}`] ? (
                          accessgroups.discrepanciesManage ? (
                            <Select
                              pretty
                              searchable={false}
                              clearable={false}
                              disabled={UI.progress}
                              className="discrepancy-field"
                              options={priorityOptions}
                              value={aircraft.discrepancies[discrepancyID].priority}
                              onChange={this.handleDiscrepancyChange.bind(
                                this,
                                'priority',
                                discrepancyID
                              )}
                            />
                          ) : null
                        ) : (
                          <div
                            className={`discrepancy-field form-control-static no-border
                                    ${discrepancyPriorities[discrepancy.priority].className}
                                    ${!accessgroups.discrepanciesManage ? ' no-edit' : ''}`}
                          >
                            {discrepancyPriorities[discrepancy.priority].name}
                            <span className="discrepancy-field-view-icon">
                              <span className="icon pencil" />
                            </span>
                          </div>
                        )}
                      </td>

                      <td
                        className="text-left"
                        data-field="assignTo"
                        data-id={discrepancyID}
                        onClick={
                          accessgroups.discrepanciesManage
                            ? this.handleDiscrepancyEditModalOpen
                            : null
                        }
                      >
                        {UI.modals[`DISCR-EDIT-assignTo-${discrepancyID}`] ? (
                          accessgroups.discrepanciesManage ? (
                            <Select
                              pretty
                              searchable={false}
                              clearable={false}
                              disabled={UI.progress}
                              className="discrepancy-field"
                              options={this.props.assignToOptions}
                              value={aircraft.discrepancies[discrepancyID].assignTo}
                              onChange={this.handleDiscrepancyChange.bind(
                                this,
                                'assignTo',
                                discrepancyID
                              )}
                            />
                          ) : null
                        ) : (
                          <div
                            className={`discrepancy-field form-control-static no-border
                                    ${!accessgroups.discrepanciesManage ? ' no-edit' : ''}`}
                          >
                            {discrepancy.assignedName} {discrepancy.assignedSurname}
                            <span className="discrepancy-field-view-icon">
                              <span className="icon pencil" />
                            </span>
                          </div>
                        )}
                      </td>

                      <td style={{ whiteSpace: 'pre-line' }}>
                        {formatDate(
                          discrepancyTimestamp,
                          0,
                          dateFormatSettings[user.settings.date]
                        )}
                        <br />
                        {formatDate(
                          discrepancyTimestamp,
                          0,
                          timeFormatSettings[user.settings.time]
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    <p className="form-control-static">No discrepancies defined</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<ReduxState, OwnProps, MappedState> = state => ({
  UI: state.UI,
  URL: state.URL,
  user: state.user,
  aircraft: state.aircraft,
  accessgroups: state.accessgroups,
  mechanics: state.mechanics,
  discrepanciesList: selectDiscrepancies(state),
  assignToOptions: selectAssignToOptions(state)
});

export default connect(
  mapStateToProps,
  {
    setModal,
    changeStatus,
    saveDiscrepancy,
    ...formActions
  },
  mergeActionsToProps
)(Discrepancies);
